export function formatInteger(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return new Intl.NumberFormat('en-US').format(Math.round(n))
}

export function formatCurrency(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n)
}

export function formatPercent(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return `${n.toFixed(1)}%`
}

export function formatHour(hour) {
  if (hour == null || Number.isNaN(Number(hour))) return '—'
  const normalized = ((Number(hour) % 24) + 24) % 24
  const suffix = normalized >= 12 ? 'PM' : 'AM'
  const hour12 = normalized % 12 || 12
  return `${hour12}:00 ${suffix} ET`
}

export function severityTone(severity) {
  const value = String(severity || 'info').toLowerCase()
  if (value === 'high') return 'negative'
  if (value === 'medium') return 'warning'
  return 'neutral'
}

export const RECOMMENDATION_TYPE_LABELS = {
  low_fnb_attach_rate: 'Low attach rate',
  peak_hour_staffing: 'Peak hour staffing',
  top_item_promotion: 'Top seller',
  section_conversion_gap: 'Section conversion',
}
